import styled from "@emotion/styled";

import { DEFAULT_CONTENT_WIDTH_IN_PX, UNIT_DEFAULT_PADDING, UnitsLayout } from "../Navigation/UnitsLayout/UnitsLayout";

export const FormInFormContainer = styled.div(() => ({
    minWidth: DEFAULT_CONTENT_WIDTH_IN_PX,
    minHeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    [`${UnitsLayout}`]: {
        padding: "0",
    },
}));

export const AttachmentFormContent = styled.div({
    textAlign: "center",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "600",
});

export const AttachmentFormFileInfo = styled.div({
    marginBottom: "16px",
});

export const AttachmentFormNdsSumText = styled.p({
    textAlign: "left",
    margin: "0",
    fontWeight: "600",
});

export const AttachmentFormFileNameText = styled.p({
    fontSize: "14px",
    textAlign: "left",
    fontWeight: "400",
    margin: "0 0 8px 0",
});

export const AttachmentFormActions = styled.div({
    fontSize: "14px",
    fontWeight: "400",
    alignItems: "baseline",
});

export const AttachmentFormErrorText = styled.span({
    color: "red",
});

export const AttachmentFormActionText = styled.div({
    margin: "8px 4px",
});

export const AttachmentFormEmpty = styled.div<{ isFilled: boolean }>(props => {
    if (!props.isFilled) {
        return {
            boxSizing: "border-box",
        };
    }

    return {
        maxWidth: DEFAULT_CONTENT_WIDTH_IN_PX,
        width: DEFAULT_CONTENT_WIDTH_IN_PX,
        padding: UNIT_DEFAULT_PADDING,
        boxSizing: "border-box",
        "@media screen and (max-width: 1280px)": {
            width: "100%",
        },
    };
});

export const HeaderWrapper = styled.div(() => ({
    padding: UNIT_DEFAULT_PADDING,
    paddingBottom: 0,
}));
